module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-800italic.woff?1d727abb1018c5cc6331c1e26169d590";